import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const NewConsultantSelectionModal = ({ show, handleClose, consultants, farmerId, changeConsultant }) => {
  const [selectedConsultantId, setSelectedConsultantId] = useState("");
  const handleSubmit = () => {
    // Create form data for assigning the consultant
    const formData = {
      farmerId: farmerId,
      newConsultantId: selectedConsultantId,
    };
    // Call the function to handle the assignment
    changeConsultant(formData);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Select a New Consultant</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="consultantSelect">
            <Form.Label>Select New Consultant</Form.Label>
            <Form.Control
              as="select"
              value={selectedConsultantId}
              onChange={(e) => setSelectedConsultantId(e.target.value)}
            >
              <option value="">Choose...</option>
              {consultants.map((consultant) => (
                <option key={consultant.user_id} value={consultant.user_id}>
                  {consultant.user_name} - {consultant.distance} away
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button 
        className="reject-button" 
        style={{ width: "10vw" }}
        variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button 
        className="button" 
        style={{ color: "white", width: "15vw"  }}
        onClick={handleSubmit} disabled={!selectedConsultantId}>
          Change Consultant
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewConsultantSelectionModal;
